/*
 * What AI chats take from the running client (`FrontendModule.bind`, `core/modules/bind.ts`): the
 * watch that keeps the slice's rows and titles in step with what the server would answer, the
 * outbox's transports for the module's messages, which go over HTTP, and the socket's requests for
 * typing and for a chat's terminal (`sync/binding.ts`).
 *
 * That code arrives as a chunk of its own, asked for here and bound as soon as it is there: none of
 * it is needed for the first paint, the outbox keeps an AI chat's message until its transport is
 * there, and together it is HTTP code the entry chunk has no room for (`scripts/checkBudgets.ts`).
 * This file is the whole of what the entry carries of it.
 */

import type { ModuleBindings } from "../../core/modules/registry.ts"

/** Binds the module once its chunk has arrived; the answer unbinds it, or stops a bind still on its way. */
export function bindAichatModule(b: ModuleBindings): () => void {
	let unbind: (() => void) | undefined
	let unbound = false
	void import("./sync/binding.ts").then(({ bindAichat }) => {
		if (unbound) return
		unbind = bindAichat(b.client, {
			typing: (body) => b.request("aichat.typing", body),
			terminal: {
				attach: (body) => b.request("aichat.terminal.attach", body),
				input: (body) => b.request("aichat.terminal.input", body),
			},
		})
	})
	return () => {
		unbound = true
		unbind?.()
	}
}
